import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import TextLink from '@narvar/nth-text-link';
import TextArea from '@narvar/nth-text-area';

const mapStateToProps = ({
  retailerSettings: { branding: { brand_call_to_action: brandCtaColor } = {} } = {},
}) => ({
  brandCtaColor,
});

const TextAreaContainer = styled.div`
  margin-top: 1.2rem;
  position: relative;
  label {
    font-weight: 400;
  }
`;

const InstructionsInput = ({
  onChange,
  onClick,
  brandCtaColor,
  expanded,
  value,
  buttonText,
  placeholderText,
  charLimit,
}) => (
  <div>
    <TextLink
      s={{
        margin: '0',
        color: brandCtaColor,
        hoverColor: brandCtaColor,
        textDecoration: 'underline',
      }}
      onClick={onClick}
    >
      {buttonText}
    </TextLink>
    {expanded && (
      <TextAreaContainer>
        <TextArea
          id="InstructionsInput"
          name="InstructionsInput"
          label={placeholderText}
          value={value}
          onChange={onChange}
          maxLength={charLimit}
          inputStyle={{
            resize: 'none',
          }}
        />
        <span
          style={{
            position: 'absolute',
            bottom: '0.7rem',
            right: '0.5rem',
            fontSize: '10px',
            fontWeight: '500',
            color: '#767676',
          }}
        >
          {`${value.length}/${charLimit}`}
        </span>
      </TextAreaContainer>
    )}
  </div>
);

InstructionsInput.defaultProps = {
  brandCtaColor: '#000000',
  expanded: false,
  value: '',
  buttonText: '',
  placeholderText: '',
  charLimit: 90,
};

InstructionsInput.propTypes = {
  onClick: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  brandCtaColor: PropTypes.string,
  expanded: PropTypes.bool,
  value: PropTypes.string,
  buttonText: PropTypes.string,
  placeholderText: PropTypes.string,
  charLimit: PropTypes.number,
};

export default connect(mapStateToProps)(InstructionsInput);
